module.exports = __webpack_public_path__ + "static/media/caret-down.290585c8.svg";